var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRecord = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "record_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#record_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#009EE7",
  d: "M7.999 11.332c.922 0 1.708-.325 2.358-.975.65-.65.975-1.436.975-2.358 0-.923-.325-1.709-.975-2.359a3.212 3.212 0 0 0-2.358-.975c-.923 0-1.709.325-2.359.975A3.213 3.213 0 0 0 4.665 8c0 .922.325 1.708.975 2.358.65.65 1.436.975 2.359.975Zm0 3.333a6.492 6.492 0 0 1-2.6-.525 6.732 6.732 0 0 1-2.117-1.425A6.733 6.733 0 0 1 1.857 10.6a6.492 6.492 0 0 1-.525-2.6c0-.923.175-1.79.525-2.6a6.732 6.732 0 0 1 1.425-2.117c.6-.6 1.306-1.075 2.117-1.425a6.492 6.492 0 0 1 2.6-.525c.922 0 1.789.175 2.6.525.81.35 1.516.825 2.116 1.425.6.6 1.075 1.306 1.425 2.117.35.81.525 1.677.525 2.6 0 .922-.175 1.789-.525 2.6a6.733 6.733 0 0 1-1.425 2.116c-.6.6-1.305 1.075-2.116 1.425a6.492 6.492 0 0 1-2.6.525Zm0-1.333c1.489 0 2.75-.517 3.783-1.55s1.55-2.294 1.55-3.783c0-1.49-.517-2.75-1.55-3.784-1.033-1.033-2.294-1.55-3.783-1.55-1.49 0-2.75.517-3.784 1.55C3.182 5.25 2.665 6.51 2.665 8c0 1.489.517 2.75 1.55 3.783C5.25 12.815 6.51 13.332 8 13.332Z"
}))));
export default SvgRecord;